import {
  FETCH_STOCK_LOCATION_PENDING,
  FETCH_STOCK_LOCATION_REJECTED,
  FETCH_STOCK_LOCATION_FULFILLED,
  FETCH_ALL_STOCK_LOCATIONS_FULFILLED,
  FETCH_ALL_STOCK_LOCATIONS_REJECTED,
} from '../constants/stockLocation';

const initialState = {
  stockLocation: {},
  allStockLocations: {},
  pending: true,
  error: {},
};

export const stockLocation = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_STOCK_LOCATION_PENDING:
      return { ...state, pending: true, error: {} };

    case FETCH_STOCK_LOCATION_REJECTED:
      return { ...state, pending: false, error: action.error };

    case FETCH_STOCK_LOCATION_FULFILLED: {
      const { results } = action.response;
      return {
        ...state,
        stockLocation: (results && results.length > 0 && results[0]) || {},
        pending: false,
        error: {},
      };
    }

    case FETCH_ALL_STOCK_LOCATIONS_FULFILLED: {
      const { results } = action.response;
      return {
        ...state,
        allStockLocations: (results && results.length > 0 && results) || [],
        pending: false,
        error: {},
      };
    }

    case FETCH_ALL_STOCK_LOCATIONS_REJECTED:
      return { ...state, pending: false, error: action.error };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/stockLocation.js